import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr3 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа по стълбове
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. До работа по стълбове</b> (на въздушни съобщителни линии и мрежи ВСЛМ) се допускат
        служители, които имат необходимата правоспособност, преминали са съответно обучение и
        инструктаж за безопасна работа и притежават не по-ниска от трета квалификационна група по
        безопасност на труда съгласно изискванията на Правилника по безопасността на труда при
        работа по въздушни и кабелни съобщителни линии и мрежи (Д-06- 001).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. При работа задължително</b> да се използват одобрените и предоста- вени съобразно
        степента на риска лични предпазни средства, за вида, употребата и начина на съхранение, на
        които работещите са инструктира- ни (и обучени за използването на тези ЛПС, за които това е
        необходимо).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          3. <span style={styles.warning}>Забранява се </span>
        </b>
        работа с неизправни лични предпазни средства и с такива с изтекъл срок на годност и на
        периодична проверка.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. В зависимост от височината и обекта</b> при необходимост се работи в екип с поне един
        колега.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5. Преди започване на работа:</b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - мястото трябва да се огради с конуси, с цел ограничаване преминаването на хора и
          превозни средства;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се оцени състоянието на стълба от механична гледна точка-спукан, изгнил, с падащи
          бетонни или метални елементи, висящи кабели;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - задължително трябва да провери здравината и укрепването на стълба (вкл. обтяжки, подпори
          и др.). При откриване на повреда по стълба техникът трябва да уведоми отговорния
          ръководител на работата;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се направи проверка за наличие на напрежение върху стълба с указател за напрежение с
          дистанционно мерене;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се избере подходящо място за поставяне на стълбата;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - трябва да провери изправността на предпазния колан, въжето, карабинките,
          инструменталната чанта и преносимата стълба;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - при качване на стълбата при работа на стълб трябва да си оборудван с необходимите
          предпазни средства и облекло - работно облекло, работни обувки, указател за напрежение с
          дистанционно мерене, обезопасителен колан и каска.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          6.
          <span style={styles.warning}>Забранява се </span>
          качването{' '}
        </b>
        и работата по неизправни, неукрепени, нетрамбовани или разкопани стълбове.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. При работа върху стълб</b> инструментите и частите да се държат в инструменталната
        чанта. По-тежките инструменти и части да се подават на техника с въже, след окончателното му
        устойчиво установяване върху стълба.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          8. <span style={styles.warning}>Забранено е </span>
        </b>
        подаването на материали и инструменти на работещия на стълба чрез подхвърляне, както и
        окачването на инструментите от работещия върху кабелите и приспособленията за тяхното
        закрепване върху стълба.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9. Работата на стълб</b>, по който има сняг или лед, да става след почистването му. При
        невъзможност за това, работата се прекратява.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10. По време на работа върху стълба </b>служителят трябва задължително да се привързва с
        предпазен колан и да има поставена върху главата си каска.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11. При работа върху стълб</b>, единичните стълби с дължина по-голяма от 5 м,
        задължително се обезопасяват срещу приплъзване с помощта на колан, чийто краища са захванати
        здраво за стъпало. Коланът се навива около стълба, перпендикулярно на равнината на стълбата.
        В горния и край задължително се монтира скобата осигуряваща защита от обръщане в страни.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>12. При работа върху ъглов стълб</b>, служителят да застава от страната на по-големия
        ъгъл, образуван от кабелите.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          13. <span style={styles.warning}>Забранява се </span>
        </b>
        стоенето и работата под стълб, върху който се работи, освен когато е необходимо да се окаже
        съдействие на работещия върху стълба. След оказване на съдействието работещият незабавно се
        отдалечава на безопасно разстояние.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          14. <span style={styles.warning}>Забранява се</span>{' '}
        </b>
        стоенето и преминаването на странични лица на разстояние по-малко от 3 метра от стълб, върху
        който се работи.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr3;
